import type { $Fetch } from 'ofetch';
import type { ProtocoloGateway } from '@/application/port/out/ProtocoloGateway';
import type { Protocolo } from '@/domain/model/Protocolo';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpProtocoloGateway implements ProtocoloGateway {
  constructor(private readonly client: $Fetch) {}

  async listByAluno(alunoId: string): Promise<Protocolo[]> {
    const res = await this.client<ApiResponse<Protocolo[]>>(
      `/api/v1/protocolos/aluno/${encodeURIComponent(alunoId)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
